import * as React from 'react';
import * as styles from './LabelsList.css';

interface ILabel {
  title: string;
  color: string;
  icon?: string;
}

export interface ILabelsListProps {
  labels: ILabel[];
}

export const LabelsList: React.VFC<ILabelsListProps> = ({ labels }) => {
  return (
    <div className={styles['labels']}>
      {labels.map(({ title, icon, color }, index) => (
        <div key={index} className={styles['label']} style={{ backgroundColor: color }}>
          {icon && <div role="img" className={styles['icon']} style={{ backgroundImage: `url(${icon})` }} />}
          {title}
        </div>
      ))}
    </div>
  );
};
